
//Desktop Search dropdown
if ($('.search.desktop').length > 0) {
  $('.search.desktop').click(function() {
    $('.search-form.desktop').toggleClass('active');
  });
}

// Find in Page for Cut Sheets search
if ($('.cut-sheets').length > 0) {

  $('.cut-sheet-items > li ul').addClass('sheet-list');

  $('.cut-sheet-items > li h3').click(function() {
    $(this).toggleClass('active');
    $(this).siblings('ul.sheet-list').slideToggle();
  });

  $('#searchText').hideseek();

}

/*****************************
LANDING PAGES
*****************************/


if ($('.landing-page').length > 0) {

  //grid section
  if ($('.snippet-grid').length > 0) {

    // Dynamic Image Replacement
    $('.snippet-grid-block.image').each(function() {

      var imgSrc = $(this).children('img').prop('src');

      $(this).css('background-image','url('+imgSrc+')');
      $(this).children('img').hide();
    });
  }


}

// blog categories

function swapCategory(newcategory){
  console.log('switch!');
  window.location = "/blogs/news/tagged/" + newcategory;
}
const blogCategory = document.querySelector("#blogCategories");
if (blogCategory) {
  blogCategory.addEventListener("change",function() {
    swapCategory(this.value);
  });
}


/****************************
PPC CONVERSION
*****************************/
$('.product-form--atc .button--print').click(function(e){
    e.preventDefault();
	window.print();
    return gtag_report_conversion(this.id);
});